import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { RecipeReview } from '../../models/recipe-review.model';

const base_url = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class RecipeReviewsService {

  private headers: object;
  private uid: string;

  constructor(  private http: HttpClient,
    private authService: AuthService  ) {
      this.headers = authService.headers;
      this.uid = authService.uid;
    }

  get( from: number, limit: number, friends: boolean = false, location?: any ) {
    
    return this.http.get( `${ base_url }/review/recipes?from=${from}&limit=${limit}&location=${location}${friends?(`&friends=${this.authService.user.follow?.users?.array}`):''}` )
    .pipe(
      tap( (resp: any) => {
        return resp;
      }),
      catchError( error => {
        return of(false)
      } )
    );

  }

  getFilterId( id: string, from: number, limit: number, location?: any ) {

    return this.http.get( `${ base_url }/review/recipes/${ id }?from=${from}&limit=${limit}&location=${location}` )
    .pipe(
      tap( (resp: any) => {
        return resp;
      }),
      catchError( error => {
        return of(false)
      } )
    );

  }

  getById( id: string, from: number, limit: number, friends: string[] | undefined = undefined ) {

    return this.http.get( `${ base_url }/review/recipes/recipe/${ id }?from=${ from }&limit=${ limit }${this.uid?(`&uid=${ this.uid }`):''}${friends?`&friends=${friends}`:''}` )
    .pipe(
      tap( (resp: any) => {
        return resp;
      }),
      catchError( error => {
        return of(false)
      } )
    );

  }
  
  getRecipeReviewsAvg( id: string ) {

    return this.http.get( `${ base_url }/review/recipes/avg/${ id }` )
    .pipe(
      tap( (resp: any) => {
        return resp;
      }),
      catchError( error => {
        return of(false)
      } )
    );

  }

  getRecipeReviewsAvgFriends( id: string, friends: string[] | undefined = undefined ) {

    return this.http.get( `${ base_url }/review/recipes/avg/friends/${ id }${friends?`?friends=${friends}`:''}` )
    .pipe(
      tap( (resp: any) => {
        return resp;
      }),
      catchError( error => {
        return of(false)
      } )
    );

  }

  createRecipeReview( review: RecipeReview ) {
    
    return this.http.post( `${ base_url }/review/recipes`, review, this.headers )
              .pipe(
                tap( (resp: any) => {
                  return resp;
                }),
                catchError( error => {
                  return of(false)
                } )
              );
    
  }


  updateRecipeReview( id: string | undefined, review: RecipeReview ) {

    return this.http.put( `${ base_url }/review/recipes/${ id }`, review, this.headers )
              .pipe(
                tap( (resp: any) => {
                  return resp;
                }),
                catchError( error => {
                  return of(false)
                } )
              );

  }

  delete( id: string | undefined ) {

    return this.http.delete( `${ base_url }/review/recipes/${ id }`, this.headers )
              .pipe(
                tap( (resp: any) => {
                  return resp;
                }),
                catchError( error => {
                  return of(false)
                } )
              );

  }


}
